import setTopAnim from "./setTopAnim";
import Macy from "macy";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const setMaronryLayout = () => {
  const target = document.querySelector('.js-masonry-wrap-top');

  if(target) {
    const videos = target.querySelectorAll('video');
    let videosLoaded = 0;
  
    function setInviewAnim() {
      function addInviewAnim(el, triggerClass, offset) {
        gsap.utils.toArray(el).forEach((el) => {
          ScrollTrigger.create({
            trigger: el,
            markers: false,
            start: "top " +  offset,
            toggleClass: {
              targets: el,
              className: triggerClass
            },
            once: true,
          });
        })
      }
    
      addInviewAnim('.entries-item', 'animate', '75%');
    };
  
    function setLayout() {
      var macy = Macy({
        container: target,
        trueOrder: false,
        waitForImages: false,
        margin: {
          x: 50,
          y: 75,
        },
        columns: 3,
        breakAt: {
          768: {
            columns: 2,
            margin: {
              x: 25,
              y: 40,
            }
          }
        }
      });

      macy.on(macy.constants.EVENT_IMAGE_COMPLETE, function (ctx) {
        setInviewAnim();
        setTopAnim();
      });
    }
    
    function setVideoSize () {
      for(const video of videos) {
        let width = video.videoWidth;
        let height = video.videoHeight;
        const aspect = height / width * 100;
        const parent = video.parentNode;
        parent.style.paddingTop = aspect + '%';
      }
      setLayout();
    }
    
    function videoLoaded() {
      // console.log(this)
      videosLoaded++;
      if (videosLoaded === videos.length) {
        setVideoSize();
      }
    }
    
    if(videos.length) {
      videos.forEach(function(video) {
        if(video.readyState > 0) {
					videoLoaded()
				} else {
					video.addEventListener('loadedmetadata', function() {
						videoLoaded()
					});
				}
      });
    } else {
      setLayout();
    }
  }

};

export default setMaronryLayout;
